<template>
    <div class="search-bar">
        <form class="form-inline">
            <div class="form-group mr-2">
                <label class="mr-sm-2">Pencarian</label>
                <input type="text" v-model="searchText" class="form-control" @keyup.enter="doSearch"
                    placeholder="kode, nama..." data-lpignore="true">
            </div>
            <div class="form-group">
                <button class="btn btn-primary" @click.prevent="doSearch">Cari</button>
                <button class="btn btn-light" @click.prevent="resetSearch">Reset</button>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            searchText: '',
        }
    },

    methods: {
        doSearch() {
            this.$emit('search-set', this.searchText);
        },
        resetSearch() {
            this.searchText = ''
            this.$emit('search-reset')
        }
    }
}
</script>
<style>
.search-bar {
    padding: 10px;
}
</style>
